import LuAgency from './LuAgency'
import TrackedBill from './TrackedBill'
import LuTrackedBillPermission from './LuTrackedBillPermission'
export default class TrackedBillAgency {
  constructor(objIn = {}) {
    const defaults = {
      //ID is required
      ID: 0,
      //TrackedBillID is required
      TrackedBillID: 0,
      //AgencyID is required
      AgencyID: 0,
      //TrackedBillPermissionID is required
      TrackedBillPermissionID: 0,
    }
    let obj = {}
    Object.assign(obj, defaults, objIn)
    this.ID = obj.ID
    this.TrackedBillID = obj.TrackedBillID
    this.AgencyID = obj.AgencyID
    this.TrackedBillPermissionID = obj.TrackedBillPermissionID
    this.Agency = new LuAgency(obj.Agency || {})
    this.TrackedBill = new TrackedBill(obj.TrackedBill || {})
    this.TrackedBillPermission = new LuTrackedBillPermission(obj.TrackedBillPermission || {})
  }
  removeRelated() {
    let obj = Object.assign({}, this)
    obj.Agency = null
    obj.TrackedBill = null
    obj.TrackedBillPermission = null
    return obj
  }
  root() {
    let obj = Object.assign({}, this)
    obj.Agency = null
    obj.TrackedBill = null
    obj.TrackedBillPermission = null
    return obj
  }
}
